import SliderCourseLain from "./SliderCourseLain";

export { SliderCourseLain };
